import Vue from "vue";
import { Component } from "vue-property-decorator";
import { IRole, IUser, IPrAffiliateGroupedByType } from "@/models";
import { PeoplePicker} from "@/components";
import { Roles } from "@/enums";
@Component({
    name: "unauthorized",
    components: {
        PeoplePicker,
    },
})
export default class Unauthorized extends Vue {
    public loading = false;

    public modal = false;

    public filterShowInactive = false;

    public searchPrAffiliate: string = null;

    public selectedPrAffiliate: any[] = [];

    public search = "";

    public filterRoleId = 1;

    public prAffiliates: IPrAffiliateGroupedByType[] = [];

    public user: IUser = {
        userId: 0,
        email: "",
        name: "",
        userUniqueId: "",
        role: "",
        roleId: Roles.PrAffiliate,
        isActive: true,
        prAffiliatePermissions: [],
    };

    public headers = [
        { text: "Name", value: "name", width: "20%" },
        { text: "Email", value: "email", width: "45%" },
        { text: "Active", value: "isActive", width: "10%" },
        { text: "Role", value: "roleId", width: "15%", filterable: false },
        { text: "Actions", value: "actions", width: "10%", sortable: false },
    ];

    public get isAuthenticated(): boolean {
        return this.$store.getters["account/isAuthenticated"];
    }

    get roles(): IRole[] {
        return this.$store.getters["app/unauthorizeRoles"];
    }

    async submit(): Promise<void> {
        this.loading = true;
        try {
            this.user.prAffiliatePermissions = this.selectedPrAffiliate.map(item => ({prAffiliateId: Number(item.id)}));
            await this.$store.dispatch("app/sendRequestAccess", this.user);
            this.$notify({ type: "success", duration: 5000, text: "The request has been successfully send."});
            const account = this.$store.dispatch("account/loadAccount");
            const user = this.$store.dispatch("account/loadUser");
            await Promise.all([account, user]);
            this.$router.push("/auth");
        }
        catch (error) {
            let msg = error;
            if (error.toString().includes("405")) {
                msg = "You already have access to the application, check with an administrator that your account is active";
            }

            this.$notify({ type: "error", duration: 5000, text:`${msg}.`});
        }
        this.loading = false;
    }

    onSelected(e: IPrAffiliateGroupedByType[]): void {
        if (e.length > 0) {
            if (e[e.length -1].id > 9996) {
                this.selectedPrAffiliate = [];
            }
            else {
                this.selectedPrAffiliate = [e[e.length - 1]];
            }
        }
    }

    isPrAffiliateUser(user: IUser): boolean {
        return user.roleId === Roles.PrAffiliate;
    }

    initPrAffiliates(): void {
        const prAffiliatesTemp = this.$store.getters["app/prAffiliates"];
        if (prAffiliatesTemp !== null && prAffiliatesTemp.length > 0) {
            const prAffiliatesGroupedTypes: IPrAffiliateGroupedByType[] = [
                {
                    id:9997,
                    name:"Brand Co",
                    children: prAffiliatesTemp.filter(x => x.type === 1).map(item => ({id:item.prAffiliateId, name: item.name})),
                },
                {
                    id:9998,
                    name:"Market Co",
                    children: prAffiliatesTemp.filter(x => x.type === 2).map(item => ({id:item.prAffiliateId, name: item.name})),
                },
                {
                    id:9999,
                    name:"Other Team",
                    children: prAffiliatesTemp.filter(x => x.type === 3).map(item => ({id:item.prAffiliateId, name: item.name})),
                },
            ];
            this.prAffiliates = prAffiliatesGroupedTypes;
        }
    }

    async mounted(): Promise<void> {
        this.loading = true;
        try {
            await this.$store.dispatch("app/loadUnauthorizeRoles", true);
            await this.$store.dispatch("app/loadAllPrAffiliate", true);
            this.initPrAffiliates();

            this.user.userUniqueId = this.$store.getters["account/userId"];
            this.user.email = this.$store.getters["account/userEmail"];
            this.user.name = this.$store.getters["account/username"];
            this.user.roleId = Roles.PrAffiliate;
        }
        catch (error) {
            this.$emit("error", error);
        }
        this.loading = false;
    }
}
